<template>
  <user-form mode="create" />
</template>

<script>
import Form from "./Form.vue";
export default {
  name: "UsersCreate",
  components: {
    UserForm: Form,
  },
};
</script>
